<div class="d-flex dropzone-documents"
    [ngClass]="{'zone-noitem': request.documentInfo === null || request.documentInfo === undefined || request.documentInfo.length === 0, 'disabledDiv': (maxDocumentAmount != 0 && maxDocumentAmount != undefined && request && request.documentInfo && request.documentInfo!.length >= maxDocumentAmount! ) }"
    (fileDropped)="OnFileSelected($event)" (drop)="OnFileSelected($event)" (dragover)="onDragOver($event)"
    draggable="true" appDragDropFileUpload>
    <div class="align-items-center m-auto justify-content-center text-center">
        <i class="d-none d-lg-block bi bi-file-earmark-plus actionIcon" aria-hidden="true"></i>
        <p class="zone-noitem-hide"
            *ngIf="request.documentInfo === null || request.documentInfo === undefined || request.documentInfo.length === 0"
            translate="Request.DropFilesHere"></p>
        <p class="zone-noitem-hide"
            *ngIf="request.documentInfo === null || request.documentInfo === undefined || request.documentInfo.length === 0"
            translate="Request.DropFilesOr"></p>
        <div class="dropdown uploadBoxDropdown">
            <input type="file" class="file-input" style="display: none;" (change)="OnFileSelected($event)" #fileUpload
                multiple>
            <button class="btn btn-sm btn-success dropdown-toggle" type="button" data-bs-toggle="dropdown"
                aria-expanded="false" translate="Button.AddFiles"></button>
            <div class="dropdown">
                <ul class="dropdown-menu w-auto">
                    <li><a class="dropdown-item" (click)="fileUpload.click()" translate="Button.Upload"></a></li>
                    <li *ngIf="showMSplugins"><a class="dropdown-item" (click)="addDocumentsCloudLocation()" translate="Button.FromCloud"></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>